import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import {ServicoApiService} from "../../shared/servico-api.service";
import {PlanoService} from "../../../planos/shared/plano.service";
import {ServicoNavigationService} from "../../shared/servico-navigation.service";
import {planosStorage, referenciaTempo} from "../../../planos/shared/data.service";
import {servicosStorage, servicosQuery} from "../../shared/data.service";
import {AutoCompleteService} from "../../../../shared/components/autocomplete/autocomplete.service";
import {UtilService} from "../../../../shared/services/util.service";
import {FormaControleService} from "../../../../bens/formas-controle/shared/forma-controle.service";
import {OdometroHorimetroService} from "../../../odometros-horimetros/shared/odometro-horimetro.service";

@Component({
    selector: 'app-servico-plano-form',
    template: require('./servico-plano-form.component.html'),
    styles: [require('./servico-plano-form.component.css')]
})
export class ServicoPlanoFormComponent implements OnInit {
    @Input() servicoObject: any = {};
    @Output() submitEvent: EventEmitter<any> = new EventEmitter();
    @Output() serviceNewEvent: EventEmitter<any> = new EventEmitter();

    newObject: any = {};
    submitted: boolean = false;
    servicoQuery: any;
    servicoSelectId: string = 'servico';
    referenciaTempoList: any[] = [];

    form2: FormGroup;
    servico = new FormControl('', Validators.required);
    periodicidadeOdometroHorimetro = new FormControl('');
    alertaInicioOdometroHorimetro = new FormControl('');
    periodicidadeTempo = new FormControl('');
    alertaInicioTempo = new FormControl('');
    referenciaTempo = new FormControl('');

    constructor(
        private _servicoApiService: ServicoApiService,
        private _servicoNavigationService: ServicoNavigationService,
        private _planoService: PlanoService,
        private _autocompleteService: AutoCompleteService,
        private _formaControleService: FormaControleService,
        private _odometroHorimetroService: OdometroHorimetroService,
        private _utilService: UtilService,
        private _fb: FormBuilder
    ) {
        this.form2 = _fb.group({
            servico: this.servico,
            periodicidadeOdometroHorimetro: this.periodicidadeOdometroHorimetro,
            alertaInicioOdometroHorimetro: this.alertaInicioOdometroHorimetro,
            periodicidadeTempo: this.periodicidadeTempo,
            alertaInicioTempo: this.alertaInicioTempo,
            referenciaTempo: this.referenciaTempo
        });
    }

    ngOnInit() {
        this.servicoQuery = this._utilService.cloneObject(servicosQuery);
        this.referenciaTempoList = this._utilService.cloneObject(referenciaTempo);
        this.newItem();

        if (this.servicoObject) {
            if (this.servicoObject.id) {
                let text = this._autocompleteService.getTextSelect2(this.servicoObject, 'descricao');
                let selectObject: any = {text: text, id: this.servicoObject.id};

                this._autocompleteService.createOptionOnSelect2(this.servicoSelectId, selectObject);
                this._autocompleteService.setValueOnSelect2(selectObject.id, this.servicoSelectId);
                this._utilService.setSelectOnFormControl(this.form2, 'servico', this.servicoObject);
            }
        }
    }

    onSubmit(evt: any) {
        this.submitted = true;
        if(evt.valid) {
            let object: any = this._utilService.cloneObject(this.newObject);

            if (this.servicoObject.id) {
                let text = this._autocompleteService.getTextSelect2(this.servicoObject, 'descricao');
                object.servico = {id: this.servicoObject.id, descricao: text};

                this._autocompleteService.setValueOnSelect2(null, this.servicoSelectId);
                this._utilService.setSelectOnFormControl(this.form2, 'servico', {});
                this.submitted = false;
                this.newItem();

                object.periodicidadeOdometroHorimetro = this._odometroHorimetroService.setMask(object.periodicidadeOdometroHorimetro);
                object.periodicidadeOdometroHorimetro = this._formaControleService.submitOdometroHorimetro(object.periodicidadeOdometroHorimetro);

                this.submitEvent.next(object);
            }
        }
    }

    getServicoObject(object: any) {
        if(object.novo) {
            this.serviceNewEvent.next(object);

            this._servicoNavigationService.goToNew();
        } else {
            this.servicoObject = object;
            this._utilService.setSelectOnFormControl(this.form2, 'servico', object);
        }
    }

    private newItem() {
        let object: any = {
            periodicidadeOdometroHorimetro: null,
            alertaInicioOdometroHorimetro: null,
            periodicidadeTempo: null,
            alertaInicioTempo: null,
            referenciaTempo: this.referenciaTempoList[0],
            servico: {}
        };
        this.newObject = object;
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/servicos/servico-planos/servico-plano-form/servico-plano-form.component.ts
 **/